import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

/**
 * Converts text with ^...^ markers into HTML with superscript tags.
 *
 * Usage:
 *   {{ 'Apple^®^' | superscript }}
 *   Output: Apple<sup>®</sup>
 *
 * Example:
 *   'Brand^TM^' → 'Brand<sup>TM</sup>'
 */
@Pipe({
  name: 'superscript',
  standalone: true,
})
export class SuperscriptPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(value: string | null | undefined): SafeHtml {
    if (!value) {
      return '';
    }

    // Replace all ^text^ patterns with <sup>text</sup>
    const transformed = value.replace(/\^([^^]+)\^/g, '<sup>$1</sup>');

    // Sanitize and return as SafeHtml
    return this.sanitizer.sanitize(1, transformed) || '';
  }
}
